
const EditableChoice = function(element) {
    this.element = $(element);
    this.group = this.element.closest('.input-group');
    this.edit = this.group.find('[data-edit]');

    this.createRoute = this.element.attr('data-create-route');
    this.editRoute   = this.element.attr('data-edit-route');
    this.getRoute    = this.element.attr('data-get-route');
    this.paramName   = this.element.attr('data-param-name');
    this.choiceLabel = this.element.attr('data-choice-label');

    // Mise à jour
    this.element.on('change', () => {
        this.updateEditButton();
    });

    this.group.on('form-success.modal', '[data-create]', (event, response) => {
        this.addElement(response.id);
    });
    this.group.on('form-success.modal', '[data-edit]', (event, response) => {
        this.updateElement(response.id);
    });

    this.updateEditButton();
};


$.extend(EditableChoice.prototype, {
    updateEditButton: function() {
        const id = this.element.val();

        if (id) {
            // Mode édition
            this.edit.removeAttr('data-create').attr('data-edit', '');
            this.edit.attr('data-href', Routing.generate(this.editRoute, this.makeParams(id)));
            this.edit.find('i').removeClass('zmdi-plus').addClass('zmdi-edit');
        } else {
            // Mode création
            this.edit.attr('data-create', '').removeAttr('data-edit');
            this.edit.attr('data-href', Routing.generate(this.createRoute));
            this.edit.find('i').addClass('zmdi-plus').removeClass('zmdi-edit');
        }
    },

    makeParams: function(id) {
        const params = {};
        params[this.paramName] = id;

        return params;
    },

    addElement: function(id) {
        $.ajax({
            url: Routing.generate(this.getRoute, this.makeParams(id)),
            dataType: 'json',
            success: (response) => {
                const option = $('<option>', {
                    value: id,
                    text: response[this.choiceLabel]
                });

                option.appendTo(this.element).prop('selected', true);
                this.element.selectpicker('refresh');
                this.element.trigger('change');
            }
        })
    },

    updateElement: function(id) {
        $.ajax({
            url: Routing.generate(this.getRoute, this.makeParams(id)),
            dataType: 'json',
            success: (response) => {
                const option = this.element.find('option[value=' + id + ']');
                option.text(response[this.choiceLabel]);

                this.element.selectpicker('refresh');
                this.element.trigger('change');
            }
        })
    }
});



const editableChoice = () => {
    const selector = 'select[data-editable-choice]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new EditableChoice(this);
    });
};

export { editableChoice }


// WEBPACK FOOTER //
// ./js/form/editableChoice.js